import React from "react";

const Spinner = () => {
  const dots = Array.from({ length: 8 });

  return (
    <>
      <style>{`
        @keyframes custom-spinner {
          0% { transform: rotate(0deg) scale(1); }
          50% { transform: rotate(180deg) scale(1.05); }
          100% { transform: rotate(360deg) scale(1); }
        }
        .animate-custom {
          animation: custom-spinner 4s ease-in-out infinite;
        }
      `}</style>

      <div 
        className="relative flex items-center justify-center animate-custom" 
        style={{ width: '254px', height: '254px' }}
      >
        {dots.map((_, i) => {
          const angle = (i * 360) / 8;
          const colors = [
            "#E2B042", "#D4C180", "#BDB99B", "#A4B1A6", 
            "#A8B9B7", "#C5D0D6", "#E5EBF0", "#F0F4F8"
          ];

          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: "38.87px",
                height: "38.87px",
                backgroundColor: colors[i],
                transform: `rotate(${angle}deg) translate(107.5px)`,
              }}
            />
          );
        })}
      </div>
    </>
  );
};

export default Spinner;